import { LDClient } from "launchdarkly-react-client-sdk";
import { Usuario } from "shared/interfaces/Usuario";

const initLDUser = (loggedUser: Usuario, ldClient: LDClient | undefined) => {
  if (ldClient && loggedUser.login && loggedUser.id) {
    const artist = loggedUser.userArtists?.[0];
    ldClient.identify({
      kind: "user",
      key: loggedUser.id.toString(),
      email: loggedUser.login,
      typeUser: loggedUser.typeAccess,
      earlyAdopter: loggedUser.earlyAdopterAccess,
      loggedUserCreatedOn: loggedUser.createdOn
        ? new Date(loggedUser.createdOn).getTime()
        : undefined,
      artistId: artist?.id?.toString(),
      artistName: artist?.name,
      artistCountry: artist?.countryCode,
      artistLevel: artist?.lastStage,
      artistGenres: artist?.genreCodes,
      artistCashAdvanceAvailable: artist?.cashAdvanceAvailable,
      artistCashAdvanceTotalEstimated: artist?.cashAdvanceTotalEstimated,
      artistCashAdvanceTotalEstimatedCurrency:
        artist?.cashAdvanceTotalEstimatedCurrency,
    });
  }
};

export default initLDUser;
